export enum SCRIPT_STATUS {
  NOSHOW = 'no_show',
  RECORD_NOT_ALLOWED = 'no_record',
  IN_PROGRESS = 'in_progress',
  READY = 'ready',
}
